module.exports = __webpack_public_path__ + "images/bannerFR-164c1dd90a910a9c68d1eeadd306ea19.png";